import { status } from 'skin/event/status';
import table from './table';

const tariff = (obj, form, story, data, d, action) => {
	console.log('[Трафик - форма] событие', obj);
	switch (obj.type) {
		case 'control':
			return table(obj, form, story, data, d, action);
		case 'table':
			return table(obj, form, story, data, d, action);
		default:
	}
	return status.action;
};

export default tariff;